import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "FavoritesPicker", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var FavoritesPicker = createLazyComponent(lazyModule, function (m) { return m.FavoritesPicker; });
//# sourceMappingURL=index.js.map